var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 45,
    viewBox: "0 0 71 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4654 38.3072C33.6255 43.1218 7.331 48.9045 6.94202 25.1686C6.94202 25.1686 7.7459 15.9716 19.0261 15.3925C19.0261 15.3925 19.4064 7.22408 28.0243 6.2992C32.6574 5.79786 37.9214 10.5692 38.4919 15.5913C38.4919 15.5913 49.8931 13.4822 50.3858 24.5981C50.5587 28.4706 49.6857 35.0572 38.6907 34.7719C38.6907 34.7719 32.3289 33.9075 31.4645 24.0709C29.6752 43.1132 57.2058 42.0068 57.6034 24.7105C57.7763 17.2336 52.9876 9.54063 42.2001 10.9841C36.2878 -3.89185 20.5474 -3.03612 14.6869 10.7594C6.31103 10.7594 -0.094037 17.2077 0.0010449 25.6268C0.320866 52.7251 38.0338 44.5567 70.4654 38.3072Z",
    fill: "#24339B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherJs);
export default __webpack_public_path__ + "static/media/etherJs.db839e352336034d0130460d33262ef1.svg";
export { ForwardRef as ReactComponent };